/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type MallEdit_mall$ref: FragmentReference;
declare export opaque type MallEdit_mall$fragmentType: MallEdit_mall$ref;
export type MallEdit_mall = {|
  +name: string,
  +phoneNumber: string,
  +email: string,
  +pdfMapUrl: ?string,
  +address: string,
  +smallMapUrl: ?string,
  +largeMapUrl: ?string,
  +mondayOpening: number,
  +mondayClosing: number,
  +tuesdayOpening: number,
  +tuesdayClosing: number,
  +wednesdayOpening: number,
  +wednesdayClosing: number,
  +thursdayOpening: number,
  +thursdayClosing: number,
  +fridayOpening: number,
  +fridayClosing: number,
  +saturdayOpening: number,
  +saturdayClosing: number,
  +sundayOpening: number,
  +sundayClosing: number,
  +$refType: MallEdit_mall$ref,
|};
export type MallEdit_mall$data = MallEdit_mall;
export type MallEdit_mall$key = {
  +$data?: MallEdit_mall$data,
  +$fragmentRefs: MallEdit_mall$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MallEdit_mall",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phoneNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pdfMapUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "address",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "smallMapUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "largeMapUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mondayOpening",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mondayClosing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tuesdayOpening",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tuesdayClosing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "wednesdayOpening",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "wednesdayClosing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thursdayOpening",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thursdayClosing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fridayOpening",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fridayClosing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "saturdayOpening",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "saturdayClosing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sundayOpening",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sundayClosing",
      "storageKey": null
    }
  ],
  "type": "Mall"
};
// prettier-ignore
(node/*: any*/).hash = '0253b86135a1a8469df74b86a86f5e2b';

module.exports = node;
